import React, { useRef, useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import ProfileDetail from './components/ProfileDetail';
import PageNavigation from './components/PageNavigation';
import Footer from './components/Footer';
import Resume from './components/Resume';
import Experience from './components/Experience';
import Availability from './components/Availability';
import ShadowBtn from '../../Components/ShadowBtn';
import CustomModal from '../../Components/CustomModal';
import HeaderAlt from '../../Components/HeaderAlt';
import AcademicBackground from './components/AcademicBackground';
import Button from '../../Components/ui/button/Button';
import AvailabilitySchedule from './components/AvailabilitySchedule';
import SignUpPopup from './components/SignupPopup';

const TutorDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showSignUpModal, setShowSignUpModal] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [videoUrl, setVideoUrl] = useState('');
  // eslint-disable-next-line no-unused-vars
  const [profilePictureSrc, setProfilePictureSrc] = useState('');
  // eslint-disable-next-line no-unused-vars
  const [resumeUrl, setResumeUrl] = useState('');

  const [openVideoModal, setOpenVideoModal] = useState(false);
  const [openAvailabilityScheduleModal, setOpenAvailabilityScheduleModal] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    if (!location.state) {
      navigate('/tutors');
    }

    const fetchData = async () => {
      const controller = new AbortController();
      try {
        await fetchTutorFiles();
      } catch (error) {
        if (controller.signal.aborted) {
          // Intentionally left empty
        } else {
          console.error(error);
        }
      }

      return () => controller.abort(); // Cleanup if the component unmounts & cancel ongoing asynchronous fetches
    };

    fetchData();
  }, [location.state, navigate]);

  async function fetchTutorFiles() {
    const fetchUrl =
      'https://4r2btbgx96.execute-api.us-east-1.amazonaws.com/dev/get-tutor-details?tutor_id=' +
      tutorDetails.tutorId;
    try {
      const response = await axios.get(fetchUrl);

      const allTutorDetails = JSON.parse(response.data.body);

      // Set the video URL if the tutor has an intro video
      if (allTutorDetails?.has_intro_video && allTutorDetails?.intro_video_url) {
        setVideoUrl(allTutorDetails.intro_video_url);
      } else {
        // Intentionally left empty
      }

      // Set the profile picture URL if the tutor has a profile picture
      if (allTutorDetails?.has_profile_picture && allTutorDetails?.prof_pic_source_url) {
        setProfilePictureSrc(allTutorDetails.prof_pic_source_url);
      } else {
        setProfilePictureSrc('/images/default-profile-pics/non-binary-default.png');
      }

      // Set the resume URL if available
      if (allTutorDetails?.resume_url) {
        setResumeUrl(allTutorDetails.resume_url);
      } else {
        // Intentionally left empty
      }
    } catch (error) {
      console.error(error, 'Error');
    }
  }

  const tutorDetails = location.state?.tutorDetails;

  const handleBookClick = () => {
    // setOpenAvailabilityScheduleModal(false)
    setShowSignUpModal(true);
  };

  const handleCloseModal = () => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
    setOpenVideoModal(false);
  };

  if (!tutorDetails) {
    return null;
  }

  return (
    <div className="flex flex-col bg-[#EFF7F7]">
      <HeaderAlt />
      <div className="relative bg-white pb-[72px]">
        <div className="top-0 z-[1] mx-auto flex h-full w-full max-w-[1054px] items-start justify-start gap-[35px] bg-[#EFF7F7] p-4 transition-all md:absolute md:left-1/2 md:-translate-x-1/2 md:bg-transparent md:px-3 md:pb-[72px] md:pt-[68px]">
          <div className="z-[1] flex w-full flex-col gap-4 md:sticky md:top-[68px] md:w-[305px] lg:w-[405px]">
            <div
              className="relative h-[405px] w-full cursor-pointer"
              onClick={() => setOpenVideoModal(true)}
            >
              {tutorDetails.profilePictureSrc ? (
                <img
                  src={tutorDetails.profilePictureSrc || '/images/default-profile.png'}
                  alt="tutor"
                  className="aspect-square h-full w-full rounded-3xl object-cover"
                />
              ) : (
                <div className="flex h-full w-full items-center justify-center overflow-hidden rounded-3xl bg-[#B0D2D2]">
                  <img src="/images/icons/no-profile.svg" alt="" className="w-full" />
                </div>
              )}
              {tutorDetails.tutorProfileFiles.introVideo && (
                <img
                  src="/images/icons/play.svg"
                  alt="play"
                  className="absolute bottom-4 right-4 h-12 w-12 rounded-full object-contain shadow-[0px_2.4px_7.2px_rgba(0,0,0,0.45)]"
                />
              )}
            </div>
            <ShadowBtn
              onClick={() => setOpenAvailabilityScheduleModal(true)}
              className="hidden w-full md:block"
              text="Book Now"
            />
            <button className="hidden w-full items-center justify-center gap-2 rounded-2xl border border-[#66CDCC] px-6 py-2 text-base text-[#66CDCC] md:flex">
              <img src="/images/icons/heart.svg" alt="" className="h-6 w-6 object-contain" />
              Save to my list
            </button>
          </div>
        </div>
        <div className="relative w-full rounded-b-3xl bg-[#EFF7F7] md:pt-[68px]">
          <div className="mx-auto flex w-full max-w-[1054px] items-start justify-end gap-[35px] px-4 md:px-3">
            <div className="relative z-10 w-full md:w-[calc(100%-340px)] lg:w-[calc(100%-440px)]">
              <ProfileDetail
                tutorDetails={{
                  name: tutorDetails.name,
                  bio: tutorDetails.bio,
                  coachingAreas: tutorDetails.coachingAreas.join(', '),
                  rating: 5,
                  subjects: tutorDetails.academicSubjects.join(', '),
                  hourlyRate: tutorDetails.hourlyRate,
                  academicBackground: tutorDetails.academicBackground,
                  testPrepCertifiedSAT: tutorDetails.testPrepCertifiedSAT,
                  testPrepCertifiedACT: tutorDetails.testPrepCertifiedACT,
                }}
              />
              {/* 
                            TODO THIS PAGE NEEDS TO BE CHANGED TO SOMETHING LIKE THIS 
                            
                            MORE CHANGES SHOULD COME ONCE THE TUTOR CARDS AND TUTOR PROFILES HAVE 
                            BEEN REDESIGNED TO INCORPORATE THINGS LIKE ACADEMIC BACKGROUND AND 
                            COACHING AREAS - TALK TO AKSHAY ABOUT THIS BEFORE MAKING CHANGES
                             <ProfileDetail
                                tutorDetails={{
                                    name: tutorDetails.name,
                                    bio: tutorDetails.bio,
                                    rating: 5,
                                    subjects: tutorDetails.academicSubjects,
                                    hourlyRate: tutorDetails.hourlyRate,
                                }}
                            /> */}
              <PageNavigation className="mt-auto" />
            </div>
          </div>
        </div>
        <div className="relative w-full bg-white">
          <div className="mx-auto flex w-full max-w-[1054px] items-start justify-end gap-[35px] px-3">
            <div className="relative z-10 flex w-full flex-col pt-7 md:w-[calc(100%-340px)] lg:w-[calc(100%-440px)]">
              {tutorDetails.tutorProfileFiles.resume && (
                <div className="flex flex-col gap-6" id="resume">
                  <p className="text-[22px] font-normal leading-normal tracking-[-0.44px] text-[#012E33]">
                    Resume
                  </p>
                  <div className="pb-8">
                    <Resume resumeUrl={tutorDetails.resume || '/files/default-resume.pdf'} />
                  </div>
                </div>
              )}
              <hr className="border-[#D9DFDF]" />
              <div className="flex flex-col gap-6 pt-6" id="experience">
                <p className="text-[22px] font-normal leading-normal tracking-[-0.44px] text-[#012E33]">
                  Experience
                </p>
                <div className="pb-8">
                  <Experience />
                </div>
              </div>
              <hr className="border-[#D9DFDF]" />
              <div className="mb-6 mt-[28px]">
                <AcademicBackground academics={tutorDetails.academicBackground} />
              </div>
              {/* <div className='flex flex-col gap-6 pt-6' id='AcademicBackground'>
                                <p className='font-normal text-[22px] leading-normal tracking-[-0.44px] text-[#012E33]'>Certifications</p>
                                <div className='pb-6'>
                                    <Certifications />
                                </div>
                            </div> */}
              <hr className="border-[#D9DFDF]" />
              <div className="flex flex-col gap-4 pt-6" id="availability">
                <p className="text-[22px] font-normal leading-normal tracking-[-0.44px] text-[#012E33]">
                  Availability
                </p>
                <div className="pb-6">
                  <Availability />
                </div>
              </div>
              <hr className="border-[#D9DFDF]" />
              <div className="flex flex-col gap-6 pt-6" id="reviews">
                <div className="space-y-6">
                  <div className="space-y-4">
                    <h4 className="text-[22px] font-normal leading-normal tracking-[-0.44px] text-[#012E33]">
                      Write a review about our tutors
                    </h4>
                    <p className="text-[16px]  font-normal leading-normal tracking-[-0.32px] text-[#012E33]">
                      Our tutors are tipped for reviews received from happy customers!
                    </p>
                  </div>
                  <div className="w-fit">
                    <Button
                      className="!w-[260px] !px-6 !py-2"
                      onClick={() => setOpenAvailabilityScheduleModal(true)}
                      label={'Write a review'}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="sticky bottom-0 z-10 block px-6 py-4 md:hidden">
          <ShadowBtn className="w-full" text="Book Now" />
          <button className="mt-4 flex w-full items-center justify-center gap-2 rounded-2xl border bg-[#66CDCC] px-6 py-2 text-base text-white">
            <img src="/images/icons/heart-white.svg" alt="" className="h-6 w-6 object-contain" />
            Save to my list
          </button>
        </div>
      </div>
      <Footer />

      {/* Modal for Video */}
      {tutorDetails.tutorProfileFiles.introVideo && (
        <CustomModal isOpen={openVideoModal} onClose={handleCloseModal}>
          <video
            ref={videoRef}
            src={'/videos/tutor-intro.mp4'}
            controls
            muted
            className="h-auto w-full"
          ></video>
        </CustomModal>
      )}
      <CustomModal
        className="!h-[546px] !w-[680px]"
        isOpen={openAvailabilityScheduleModal}
        onClose={() => setOpenAvailabilityScheduleModal(false)}
      >
        <AvailabilitySchedule
          name={tutorDetails.name.split(' ')[0]}
          handleBookClick={handleBookClick}
          setOpenAvailabilityScheduleModal={setOpenAvailabilityScheduleModal}
        />
      </CustomModal>
      <CustomModal
        className="max-w-[480px]"
        isOpen={showSignUpModal}
        onClose={() => setShowSignUpModal(false)}
      >
        <SignUpPopup setShowSignUpModal={setShowSignUpModal} />
      </CustomModal>
    </div>
  );
};

export default TutorDetails;
